<template lang="pug">
v-container
  v-row
    v-col(cols="12")
      h1 График вебинаров
    v-col
      .calendar
        v-overlay(:value="loading" absolute)
          v-progress-circular(indeterminate)
        //- TODO rename
        c-header(
          :schedules="schedules"
          :current-date="currentDate"
          :type="type"
          @set-day="currentDate = $event"
          @set-type="type = $event"
          @set-filters="filterFields = $event"
        )
        .calendar-month(v-if="type === VIEW_TYPES.MONTH")
          c-week
          v-slide-x-transition(hide-on-leave)
            div(:key="Number(currentDate)")
              div.calendar-month--row(v-for="(row, i) in cells" :key="i")
                div.calendar-month--cell.pa-1(v-for="(cell, index) in row" :key="index")
                  template(v-if="!cell.empty")
                    .d-flex.align-center.mb-1.mr-1
                      v-btn.rounded.mr-auto.calendar-month--cell__add-btn(
                        v-if="canCreateWebinar"
                        @click="openCreateWebinar(cell.text)"
                        color="success"
                        x-small
                        fab
                      )
                        v-icon mdi-plus
                      p.text-center.mb-0.subtitle-2 {{ cell.text }}
                    schedule(
                      @click.native="setSelectedDay(cell.text)"
                      :current-date="currentDate"
                      :day="cell.text"
                      :schedules="getDaySchedules(cell.text)"
                    )

        .calendar-week(v-if="type === VIEW_TYPES.WEEK").d-flex
          div.flex-grow-1
            .calendar-week--header.grey--text.text--darken-2
              .calendar-week--header-cell(v-for="day in weekDays")
                span.header-cell__day {{ day.getDate()  }}
                span.header-cell__week.mb-2 {{ DAYS[day.getDay()] }}
            .calendar-week--header.calendar-week__body.grey--text.text--darken-2

              .calendar-week--header-cell(
                v-for="(day, index) in weekDays"
                style="position:relative;"
              )
                schedule(
                  @click.native="setSelectedDay(day.getDate() + 1)"
                  :current-date="currentDate"
                  :day="day.getDate()"
                  :schedules="getDaySchedules(day.getDate() + 1)"
                )
  event-form(
    @addNewSchedules="addNewSchedules($event)"
    v-model="eventForm"
    :day="createDay"
  )

  dialog-all-schedules(
    :selected-day="selectedDay"
    :schedules="schedules"
    :get-organization="getOrganization"
  )
</template>

<script>
import { ACTION_LIST } from '@/modules/User/constants';
import haveRights  from '@/lib/haveRights';
import { CACHE_KEYS } from '@/store/modules/cache';
import { mapGetters, mapActions  } from 'vuex';
import DialogAllSchedules from './components/DialogAllSchedules.vue';
import Schedule from './components/Schedule.vue';
import format from 'date-fns/format/index.js';
import CHeader from './components/CalendarHeader.vue';
import CWeek from './components/CalendarWeek.vue';
import { VIEW_TYPES } from './constants';
import EventForm from './components/EventForm.vue';
import { CRUDWebinarSchedule } from '../../../services/API/_crud';
import {
  addWeeks, eachDayOfInterval, getDaysInMonth, isSameDay, lastDayOfMonth, nextMonday, subDays, subMonths, //   subMonths, lastDayOfMonth
} from 'date-fns';
import { DAYS, MONTHS } from '@/constants';
import mixinDateTime from '@/mixins/mixinDateTime';
import pfdoService from '@/services/API/_pfdo';

export default {
  components:{
    Schedule,
    CHeader,
    CWeek,
    EventForm,
    DialogAllSchedules,
  },
  mixins:[mixinDateTime],
  data() {
    return {
      createDay:null,
      eventForm: false,

      // calendar
      type: VIEW_TYPES.MONTH,
      loading: false,
      currentDate: new Date(),
      filterFields: {},
      schedules: [],

      selectedDay: null,

      pdfoOrganizations: [],
      // constants
      DAYS,
      MONTHS,
      VIEW_TYPES,
    };
  },
  computed:{
    ...mapGetters({
      'isAdmin':'auth/isAdmin',
      'user': 'auth/getUser',
    }),
    hours() {
      // const from = 2;
      const to = 22;
      return Array.from({ length: to  / 4 }).map((_, index) => {
        const hour = (index + 1) * 4;
        if (hour < 10) return `0${hour}:00`;
        return `${hour}:00`;
      });
    },
    getFirstDateOfMonth() {
      return new Date(this.currentDate.getFullYear(), this.currentDate.getMonth());
    },

    firstDayOfMonth() {
      return format(this.getFirstDateOfMonth, 'i');
    },

    weekDays() {
      const end  = subDays(addWeeks(this.currentDate, 1), 1);
      return eachDayOfInterval({ start: this.currentDate, end  });
    },

    cells() {
      const blanks = [];
      for (let i = 0; i < this.firstDayOfMonth - 1; i++) {
        blanks.push({ empty:true });
      }

      const daysInMonth = [];

      for (let d = 1; d <= getDaysInMonth(this.currentDate); d++) {
        daysInMonth.push({
          text: d,
          cell: true,
        });
      }
      const totalSlots = [...blanks, ...daysInMonth];
      const rows = [];
      let cells = [];

      totalSlots.forEach((row, i) => {
        if (i % 7 !== 0) {
          cells.push(row); // if index not equal 7 that means not go to next week
        } else {
          if (cells.length) {
            rows.push(cells); // when reach next week we contain all td in last week to rows
          }
          cells = []; // empty container
          cells.push(row); // in current loop we still push current row to new container
        }

        if (i === totalSlots.length - 1) {
          // when end loop we add remain date
          rows.push(cells);
        }
      });
      // render empty rest cells
      const restLength = rows[rows.length - 1].length;

      for (let i = 0; 7 - restLength > i; i++) {
        rows[rows.length - 1].push({ empty:true });
      }
      return rows;
    },
    filterSchedules() {
      const {
        name = '',
        type = null,
        organization_name = '',
        user_full_name = '',
      } = this.filterFields;

      const byText = (a, b) => (a || '').toLowerCase().includes((b || '').toLowerCase());

      return this.schedules.filter((item) => byText(item.name, name))
        .filter((item) => byText(item.organization_name, organization_name))
        .filter((item) => !type || type  === item.type)
        .filter((item) => byText(item.user_full_name, user_full_name));
    },
    canCreateWebinar() {
      return haveRights(this.user, [ACTION_LIST.CAN_CREATE_WEB]) && !this.isAdmin;
    },
  },
  watch:{
    currentDate:{
      immediate:true,
      async handler() {
        this.init();
      },
    },
    type(v) {
      if (v === VIEW_TYPES.WEEK) {
        this.currentDate = subDays(nextMonday(this.currentDate), 7);
      }
    },
  },
  methods: {
    ...mapActions({
      'loadToCache':'cache/loadToCache',
    }),
    getOrganization(id) {
      return this.pdfoOrganizations.find(({ id:_id }) => _id === id) || {};
    },
    async init() {
      try {
        this.loading = true;

        const end =  subMonths(lastDayOfMonth(this.currentDate), 1);
        const start = subMonths(end, 1);

        const params = {
          'search[period_start_at][from_at]': this.parseDateTime(start),
          'search[period_start_at][to_at]': this.parseDateTime(end),
          'search[period_end_at][from_at]': this.parseDateTime(start),
          'search[period_end_at][to_at]': this.parseDateTime(end),
        };
        const response = await CRUDWebinarSchedule.getAll(params);
        this.schedules = response.data.data;

        // Load to cache
        const usersIds = this.schedules.map((el) => el.user_id);
        const munIds = this.schedules.map((el) => el.municipality_id);
        const regionIds = this.schedules.map((el) => el.region_id);
        const projectIds = this.schedules.map((el) => el.project_id);
        // const userDispatcherIds = this.schedules.reduce((acc, { dispatcher_user_ids }) => [...acc, ...dispatcher_user_ids], []);
        let userDispatcherIds = [];
        this.schedules.forEach(({ dispatcher_user_ids }) => {
          if (!dispatcher_user_ids) return;
          userDispatcherIds = [...userDispatcherIds, ...dispatcher_user_ids];
        });
        await this.loadToCache({ key:CACHE_KEYS.users, ids:usersIds });
        await this.loadToCache({ key:CACHE_KEYS.municipalities, ids:munIds });
        await this.loadToCache({ key:CACHE_KEYS.regions, ids:regionIds });
        await this.loadToCache({ key:CACHE_KEYS.projects, ids:projectIds });
        if (!userDispatcherIds) return;
        pfdoService.getOrganizations({ 'search[id]':userDispatcherIds })
          .then(({ data }) => {
            this.pdfoOrganizations = data.data;
          });
      } catch (error) {
        this.$toast.error(error.response.data.result_message);
      }
      this.loading = false;
    },
    addNewSchedules(schedule) {
      this.schedules.push(schedule);
    },
    getDaySchedules(day) {
      const calendarDay = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() - 1, day);
      const filterd = this.filterSchedules.filter((schedule) => isSameDay(new Date(schedule.start_at), calendarDay));
      return filterd.sort((a, b) => new Date(a.start_at) > new Date(b.start_at));
    },
    setSelectedDay(day) {
      this.selectedDay  = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() - 1, day);
    },
    openCreateWebinar(day) {
      const date = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), day);
      this.createDay = date;
      this.eventForm = true;
    },
  },
};
</script>

<style lang="scss">
.calendar{
  position: relative;
}
.calendar-month {
  & {
    width: 100%;
    border-right: thin solid #c7c7c7;
    border-left: thin solid #c7c7c7;
    border-top: thin solid #c7c7c7;
    overflow: auto;
    border-radius: 5px;
  }

  &--row {
    display: flex;
    flex-direction: row;
    border-bottom: thin solid #c7c7c7;
  }

  &--cell {
    width: calc(100% / 7);
    height: auto;
    min-height: 100px;

    &:not(:nth-child(7n)){
      border-right: thin solid #c7c7c7;
    }

    &__add-btn {
      visibility: hidden;
    }

    &:hover {
      .calendar-month--cell__add-btn {
        visibility: initial;
      }
    }
  }

  &--event {
    border-radius: 5px;
  }
}

.calendar-week {
  & {
    width: 100%;
    border: thin solid #c7c7c7;
    overflow: auto;
    border-radius: 5px;
  }

  &--header {
    display: flex;
    flex-direction: row;

    &-cell {
      width: calc(100% / 7);
      min-width: 150px;
      display: flex;
      flex-direction: column;
      align-items: center;
      border-bottom: thin solid #c7c7c7;

      & > div {
        padding: 10px;
        width: 100%;
      }

      &:not(:nth-child(8n)){
        border-right: thin solid #c7c7c7;
      }

      .header-cell__day {
        font-size: 3rem;
      }
    }
  }

}

</style>
